import { IIdWithName } from './shared';

export class AppConstants {
  // Timing constants
  static readonly TOKEN_CHECK_INTERVAL_MS = 60000;
  static readonly TIME_DISPLAY_UPDATE_INTERVAL_MS = 10000;
  static readonly NOTIFICATION_DURATION_MS = 3000;
  static readonly MENU_CLOSE_DELAY_MS = 10;
  static readonly TOKEN_REFRESH_TOLERANCE_MS = 180000;
  // Theme constants
  static readonly DARK_MODE_CLASSES = 'icu-dark-theme';
  static readonly LIGHT_MODE_CLASSES = 'icu-light-theme';
  // Storage key
  static readonly STORAGE_KEY_PREFIX = 'icu.';
  // Language configuration
  static readonly DEFAULT_LANGUAGE = 'de-DE';
  static readonly SUPPORTED_LANGUAGES: IIdWithName[] = [
    { id: 'en', name: 'English' },
    { id: 'de-DE', name: 'Deutsch' }
  ];
}
